import React, {useState, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './ImageEditor.css.js';
import MobilePopup from '../newPopup/mobilePopup/MobilePopup';
import RegularInput from '../input/regularInpit/RegularInput';
import Btn from '../button/btn/Btn';
import Checkbox from '../checkbox/Checkbox';

function ImageEditor({imageElement, quill, onClose, showImageEditor}) {
    const {t} = useTranslation('variables');
    const [maintainAspectRatio, setMaintainAspectRatio] = useState(true);
    
    // Extract dimension from style (if set) or use natural dimension
    const getDimension = (styleProp, naturalProp) => {
        if(!imageElement) return 0;
        const styleValue = parseInt(imageElement.style[styleProp]) || 0;
        return styleValue || imageElement[naturalProp] || 0;
    };
    
    const initialWidth = getDimension('width', 'width');
    const initialHeight = getDimension('height', 'height');
    
    const [originalWidth, setOriginalWidth] = useState(initialWidth);
    const [originalHeight, setOriginalHeight] = useState(initialHeight);
    const aspectRatio = useRef((initialWidth / initialHeight) || 1);
    const popupRef = useRef(null);

    const handleClose = () => {
        showImageEditor.close();
        onClose();
    };

    const handleWidthChange = (e) => {
        const value = e.target.value;
        setOriginalWidth(parseInt(value));
        if(maintainAspectRatio && value && aspectRatio.current) {
            const newHeight = Math.round(parseInt(value) / aspectRatio.current);
            setOriginalHeight(parseInt(newHeight));
        }
    };
    const handleHeightChange = (e) => {
        const value = e.target.value;
        setOriginalHeight(parseInt(value));
        if(maintainAspectRatio && value && aspectRatio.current) {
            const newWidth = Math.round(parseInt(value) * aspectRatio.current);
            setOriginalWidth(parseInt(newWidth));
        }
    };

    const handleApply = () => {
        if(!imageElement || !quill) return;
        
        if(originalWidth) imageElement.style.width = `${originalWidth}px`;
        if(originalHeight) imageElement.style.height = `${originalHeight}px`;
        
        handleClose();
    };

    return (
        <MobilePopup
            showClass={showImageEditor.showClass}
            forwardRef={popupRef}
            close={showImageEditor.close}
            title={t('imageEditorTitle')}
            height="max-content"
            dataCyName={'imageEditor'}
            cssStyle="width: 400px; min-width: 320px; padding:20px;min-height:350px"
        >
            <css.contentWrapper>
                <css.content>
                    <css.inputGroup>
                        <Checkbox
                            selected={maintainAspectRatio}
                            onClick={setMaintainAspectRatio}
                        />
                        <css.label>{t('maintainAspectRatio')}</css.label>
                    </css.inputGroup>
                    <RegularInput
                        value={originalWidth}
                        setValue={handleWidthChange}
                        type="number"
                        text={t('widthLabel')}
                        dataCyName="imageEditorWidth"
                    />
                    <RegularInput
                        value={originalHeight}
                        setValue={handleHeightChange}
                        type="number"
                        text={t('heightLabel')}
                        dataCyName="imageEditorHeight"
                    />
                </css.content>
                <css.buttonGroup>
                    <Btn onClick={handleApply}>{t('apply')}</Btn>
                    <Btn className="white" onClick={handleClose}>{t('cancel')}</Btn>
                </css.buttonGroup>
            </css.contentWrapper>
        </MobilePopup>
    );
}

export default ImageEditor;

